module.exports = __webpack_public_path__ + "img/xnajsk1.3115af3a.jpg";